import { pathOr } from "ramda";

let selectorId = "default";
const subjects = { [selectorId]: {} };

import { useWebproductStore } from "@/stores/modules/webproduct";

export const setSelectorIdCallback = newSelectorId => {
  selectorId = newSelectorId;
  subjects[selectorId] = {};
};

const getActiveSelector = () => {
  return selectorId == "default"
    ? selectorId
    : useWebproductStore().getSelector;
};

export const registerCallback = (type, handler) => {
  if (!subjects[selectorId][type]) {
    subjects[selectorId][type] = handler;
  }
};
export const unregisterCallback = type => {
  if (subjects[selector][type]) {
    delete subjects[selector][type];
  }
};
export const isRegisteredCallback = type => {
  const appSelectorId = getActiveSelector();
  if (subjects[appSelectorId][type]) {
    return true;
  }
  return false;
};

export const callbackService = {
  sendCallback: (type, payload) => {
    const appSelectorId = getActiveSelector();
    if (subjects[appSelectorId][type]) {
      return subjects[appSelectorId][type](payload);
    }
    return null;
  },
  sendInitialCallback: (type, payload, appSelectorId) => {
    let callback = pathOr(null, [appSelectorId, type], subjects);
    if (callback) {
      return callback(payload);
    }
    callback = pathOr(null, [selectorId, type], subjects);
    if (callback) {
      return callback(payload);
    }
    return null;
  },
  callbacks: {
    beforeChangeOptionsCallback: "beforeChangeOptionsCallback",
    afterChangeOptionsCallback: "afterChangeOptionsCallback",
    afterChangePageOptionCallback: "afterChangePageOptionCallback",
    onCartSubmitCallback: "onCartSubmitCallback",
    beforeInitCallback: "beforeInitCallback",
    initFinalizeCallback: "initFinalizeCallback",
    beforePersonalizeCallback: "beforePersonalizeCallback",
    photoMappingCallback: "photoMappingCallback",
    toggleReadyToConnect: "toggleReadyToConnect",
    afterPersonalizationCallback: "afterPersonalizationCallback"
  }
};
